import React from "react";

export default function VoucherTotals({
  onAddRow,
  totalDr,
  totalCr,
  isBalanced,
  difference,
}) {
  const formatCurrency = (val) => {
    const num = Number(val) || 0;
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="vch_totals_container">
      {/* Left side: Add Row Button */}
      <div className="vch_totals_left">
        <button
          type="button"
          className="vch_add_row_btn"
          onClick={onAddRow}
        >
          <i className="fa-solid fa-plus"></i> Add Row
        </button>

        {/* Real-time Balance validation indicator based on handwritten note */}
        <div className="vch_balance_status_badge_wrapper">
          {totalDr > 0 || totalCr > 0 ? (
            isBalanced ? (
              <span className="vch_badge_balanced" title="Total Debit matches Total Credit">
                <i className="fa-solid fa-circle-check"></i> Balanced
              </span>
            ) : (
              <span
                className="vch_badge_unbalanced"
                title="Debit and Credit totals must match before saving"
              >
                <i className="fa-solid fa-triangle-exclamation"></i> Difference: ₹
                {formatCurrency(difference)} (Unbalanced)
              </span>
            )
          ) : (
            <span className="vch_badge_neutral">
              Enter amounts to balance voucher
            </span>
          )}
        </div>
      </div>

      {/* Right side: Total (₹), Dr Total, Cr Total */}
      <div className="vch_totals_right">
        <div className="vch_total_label">Total (₹)</div>
        <div className={`vch_total_amount_box vch_total_dr ${!isBalanced && totalDr > 0 ? "vch_val_mismatch" : ""}`}>
          <span className="vch_total_value">{formatCurrency(totalDr)}</span>
        </div>
        <div className={`vch_total_amount_box vch_total_cr ${!isBalanced && totalCr > 0 ? "vch_val_mismatch" : ""}`}>
          <span className="vch_total_value">{formatCurrency(totalCr)}</span>
        </div>
        <div className="vch_total_spacer" />
      </div>
    </div>
  );
}
